import { Grid, Paper, Tooltip } from '@mui/material';
import React from 'react';
import styles from './box-layout.styles';
import { Component } from 'react';
import { withStyles } from '@mui/styles';
import './index.css';
import { withTranslation } from 'react-i18next';
import groupTypes from '../common/group-types';
import LockIcon from '@mui/icons-material/Lock';

let nums = Array.from(Array(3).keys());
let nums1 = Array.from(Array(12).keys());
let elem = ['A', 'B', 'C'];
let deactivatedBin = [];
let IsSaved;
let BinIds = [];

export class Main24Layout extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillReceiveProps() {
        const { deactivatedBins } = this.props;
        if (deactivatedBins && deactivatedBins.length > 0) {
            deactivatedBins.map((item) => {
                return true
            })
        }
        else {
            deactivatedBin.map((item) => {
                return true
            })
            deactivatedBin = [];
        }
    }

    checkIsSaved = (binId) => {
        const { BinStatus } = this.props;
        if (BinStatus && BinStatus.length && BinStatus.length > 0) {
            BinStatus.map((binitem) => {
                if (binitem.bin_id === binId) {
                    IsSaved = true;
                }
                else {
                    IsSaved = false;
                }
                return true;
            })
        }
        else {
            IsSaved = false;
        }
    }

    // Extract column ID from bin ID (e.g., "A1" -> "A", "AA1" -> "AA", "A1-A12" -> "A")
    getColumnIdFromBinId = (binId) => {
        if (!binId) return null;
        // Handle formats like "A1", "AA1", "A1-A12", "AA1-AA12"
        const match = binId.match(/^([A-Z]+)\d+/);
        return match ? match[1] : null;
    };

    // Check if bin is restricted by column mappings
    isRestrictedByColumnMapping = (binId) => {
        const { columnMappings, userGroupType } = this.props;
        
        // If no column mappings, not restricted
        if (!columnMappings || !Array.isArray(columnMappings) || columnMappings.length === 0) {
            return false;
        }

        // Extract column ID from bin ID
        const columnId = this.getColumnIdFromBinId(binId);
        if (!columnId) return false;

        // Find the column mapping for this column
        const columnMapping = columnMappings.find(mapping => {
            if (!mapping || !mapping.column_id) return false;
            // Extract column letter from mapping (e.g., "A1-A12" -> "A")
            const mappingColumnId = this.getColumnIdFromBinId(mapping.column_id);
            return mappingColumnId === columnId;
        });

        // If column is mapped:
        // - If user has no group type (null), restrict it (column is assigned to a specific group)
        // - If user has a group type, restrict if it's different from the mapped group
        if (columnMapping && columnMapping.group_type_id) {
            if (!userGroupType) {
                // User has no group type, but column is mapped to a specific group - restrict it
                return true;
            } else if (columnMapping.group_type_id !== userGroupType) {
                // User has a group type, but it's different from the mapped group - restrict it
                return true;
            }
        }

        return false;
    };

    // Combined check: restricted by group type OR column mapping
    isRestricted = (groupTypeId, binId) => {
        // First check existing group type restriction
        if ([
            groupTypes.Retail, 
            groupTypes.Super, 
            groupTypes.eCommerce, 
            groupTypes.Audiology
        ].includes(groupTypeId)) {
            return true;
        }
        // Then check column mapping restriction
        if (this.isRestrictedByColumnMapping(binId)) {
            return true;
        }
        return false;
    };

    // Helper method to handle bin click with restriction check
    handleBinClick = (binId, groupTypeId, status, pm_id) => {
        // Double-check restriction before opening
        if (this.isRestricted(groupTypeId, binId)) {
            console.log('[Main24] Click blocked - bin is restricted:', binId);
            return false; // Return false to indicate click should be blocked
        }
        this.openbin(binId, status, pm_id);
        return true;
    };

    openbin = (binId, status, pm_id) => {
        // Check if bin is restricted by column mapping - don't allow opening if restricted
        if (this.isRestrictedByColumnMapping(binId)) {
            console.log('[Main24] openbin blocked - bin is restricted by column mapping:', binId);
            return; // Don't allow opening if restricted by column mapping
        }
        
        // Also check combined restriction (group type + column mapping)
        if (this.isRestricted(null, binId)) {
            console.log('[Main24] openbin blocked - bin is restricted (combined check):', binId);
            return;
        }
        
        if (status === 'Assigned' || status === 'Stocked' || status === 'Hold') {
            this.props.getPrescriptionDetails(binId, pm_id);
        }
        else {
            // Handle deactivated bins without status - allow activation
            if (this.props.deactivatedBins && this.props.deactivatedBins.includes(binId)) {
                this.props.Selectedbin(binId);
                this.props.getPrescriptionDetails(binId, pm_id);
                let items = document.getElementById(binId);
                if (items) {
                    items.style.background = 'linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(249, 27, 27) 90%)'; // deavtivated
                    items.style.color = '#ffffff'
                }
            } else {
                BinIds.map((item) => {
                    this.checkIsSaved(item);
                    if (item !== binId && IsSaved === false) {
                        var items = document.getElementById(item);
                        items.style.background = 'linear-gradient(148deg, #ffffff 30%, #d9dcdb 60%, #dcdcdc 87%)';
                    }
                    return true
                })
                BinIds = [];
                BinIds.push(binId);
                if (BinIds.length > 0) {
                    this.props.Selectedbin(binId);
                    var items = document.getElementById(binId);
                    items.style.background = 'linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(253, 253, 2) 90%)';
                }
            }
        }
    }

    render() {
        const BoxStatus = {
            ASSIGNED: '8f9c8e02-b9ee-4f29-aeea-670cef022663',
            STOCKED: '4ee90c0f-d4c3-4d53-8014-d7eac4ea2894',
            HOLD: '45593c2c-fc8c-4bf0-854e-e2bf759b7788',
            PICKED_UP: '00fe15e3-80b9-4e6f-9bf3-ad0c09a58c3e',
            CANCELLED: '8a994741-402e-4b18-a883-60da7fc94c7b',
            RETURNED: '198473ec-2e3f-42c8-a3f9-a0a3f8b4ae55',
            DEACTIVATED: '4f666da5-bfe0-4fb5-ad77-b92103881220'
        }
        const { classes, BinStatus, deactivatedBins, t, isViewPermissionAllowed, ADAData, PatientID} = this.props;
        return (
            <div className={classes.ratingContainer}>
                {nums1.map((n1) => {
                    let doorInx = n1 + 1;
                    const isdisabledDoor = Array.isArray(ADAData) && ADAData.some(function (item) {
                        return (
                            item &&
                            item.patient_id === PatientID &&
                            item.ada_compitible === true &&
                            ![7, 8, 9].includes(doorInx)
                        );
                    });
                    return (
                        <Grid
                            key={n1}
                            container
                            direction="row"
                            justify="center"
                            alignItems="center"
                            spacing={8}
                            className={classes.RemoveMargin}
                            style={{ pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                        >
                            {nums.map((n) => {
                                if ((elem[n] === 'A' || elem[n] === 'B') && (n1 >= 0 && n1 <= 5)) {
                                    if (elem[n] === 'A') {
                                        return <Grid
                                            id={elem[n] + '' + (n1 + 1)}
                                            key={n}
                                            sx={{ cursor: 'pointer', p: '4px', width: '5rem' }}
                                            style={{ pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                        >
                                        </Grid>;
                                    } else {
                                        return <Grid
                                            id={elem[n] + '' + (n1 + 1)}
                                            key={n}
                                            sx={{ cursor: 'pointer', p: '4px', width: '6rem' }}
                                            style={{ pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                        >
                                        </Grid>;
                                    }
                                } else {
                                    if (elem[n] === 'A' || elem[n] === 'B' || elem[n] === 'C') {
                                        if (BinStatus && BinStatus.length && BinStatus.length > 0) {
                                            let BinKey = elem[n] + (n1 + 1)
                                            for (var i = 0; i < BinStatus.length; i++) {
                                                let pm_id = BinStatus[i].id;
                                                let isLockedBin = BinStatus[i].is_locked;
                                                if (BinStatus[i].type_id === BoxStatus.STOCKED && BinStatus[i].bin_id === BinKey) {
                                                    return (
                                                        <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title={t("Global.Prescriptions.Status.Stocked")}>
                                                            <Grid
                                                                style={{ 
                                                                    padding: '4px',
                                                                    pointerEvents: [
                                                                        groupTypes.Retail, 
                                                                        groupTypes.Super, 
                                                                        groupTypes.eCommerce, 
                                                                        groupTypes.Audiology
                                                                    ].includes(BinStatus[i] && BinStatus[i].group_type_id) ? 'none' : (isViewPermissionAllowed ? 'auto' : 'none'), 
                                                                    cursor: [
                                                                        groupTypes.Retail, 
                                                                        groupTypes.Super, 
                                                                        groupTypes.eCommerce, 
                                                                        groupTypes.Audiology
                                                                    ].includes(BinStatus[i] && BinStatus[i].group_type_id) ? 'not-allowed' : (isViewPermissionAllowed ? 'pointer' : 'not-allowed')
                                                                }}
                                                                // eslint-disable-next-line no-loop-func
                                                                onClick={(e) => {
                                                                    const binId = elem[n] + '' + (n1 + 1);
                                                                    const groupTypeId = BinStatus[i] && BinStatus[i].group_type_id;
                                                                    if (!this.handleBinClick(binId, groupTypeId, 'Stocked', pm_id)) {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                    }
                                                                }}
                                                                key={((elem[n] + ' ' + (n1 + 1)))} 
                                                                item xs={2}
                                                                className={isdisabledDoor ? classes.disabledDoor : classes.kioskDoor}
                                                            >
                                                                <Paper
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        // Apply visual styling for column-restricted bins
                                                                        backgroundColor: this.isRestrictedByColumnMapping(elem[n] + '' + (n1 + 1)) ? '#FFE0B2' : 'transparent',
                                                                        border: this.isRestrictedByColumnMapping(elem[n] + '' + (n1 + 1)) ? '2px solid #FF9800' : 'none',
                                                                    }}
                                                                    id={elem[n] + '' + (n1 + 1)} 
                                                                    className={isLockedBin ? classes.gridPurpleBin : classes.gridOrangeback}
                                                                >
                                                                    {
                                                                            this.isRestricted(BinStatus[i] && BinStatus[i].group_type_id, elem[n] + '' + (n1 + 1))
                                                                                ? <LockIcon fontSize='12px' /> : null
                                                                    }
                                                                    &nbsp;{elem[n] + ' ' + (n1 + 1)}
                                                                </Paper>
                                                            </Grid>
                                                        </Tooltip>
                                                    );
                                                }
                                                else if (BinStatus[i].type_id === BoxStatus.ASSIGNED && BinStatus[i].bin_id === BinKey) {
                                                    return (
                                                        <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title={t("Global.Prescriptions.Status.Assigned")}>
                                                            <Grid
                                                                style={{ 
                                                                    padding: '4px', 
                                                                    pointerEvents: this.isRestricted(BinStatus[i] && BinStatus[i].group_type_id, elem[n] + '' + (n1 + 1)) ? 'none' : (isViewPermissionAllowed ? 'auto' : 'none'),
                                                                    cursor: this.isRestricted(BinStatus[i] && BinStatus[i].group_type_id, elem[n] + '' + (n1 + 1)) ? 'not-allowed' : (isViewPermissionAllowed ? 'pointer' : 'not-allowed')
                                                                }}
                                                                // eslint-disable-next-line no-loop-func
                                                                onClick={(e) => {
                                                                    const binId = elem[n] + '' + (n1 + 1);
                                                                    const groupTypeId = BinStatus[i] && BinStatus[i].group_type_id;
                                                                    if (!this.handleBinClick(binId, groupTypeId, 'Assigned', pm_id)) {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                    }
                                                                }}
                                                                key={((elem[n] + ' ' + (n1 + 1)))} 
                                                                item xs={2}
                                                                className={isdisabledDoor ? classes.disabledDoor : classes.kioskDoor}
                                                            >
                                                                <Paper
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        // Apply different styling for column-restricted bins
                                                                        backgroundColor: this.isRestrictedByColumnMapping(elem[n] + '' + (n1 + 1)) ? '#FFE0B2' : 'transparent',
                                                                        border: this.isRestrictedByColumnMapping(elem[n] + '' + (n1 + 1)) ? '2px solid #FF9800' : 'none',
                                                                    }} 
                                                                    id={elem[n] + '' + (n1 + 1)} 
                                                                    className={isLockedBin ? classes.gridPurpleBin : classes.gridBlueback}
                                                                >
                                                                    {
                                                                            this.isRestricted(BinStatus[i] && BinStatus[i].group_type_id, elem[n] + '' + (n1 + 1))
                                                                                ? <LockIcon fontSize='12px' /> : null
                                                                    }
                                                                    &nbsp;{elem[n] + ' ' + (n1 + 1)}
                                                                </Paper>
                                                            </Grid>
                                                        </Tooltip>
                                                    );
                                                }
                                                else if (BinStatus[i].type_id === BoxStatus.HOLD && BinStatus[i].bin_id === BinKey) {
                                                    return (
                                                        <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title={t("Global.Prescriptions.Status.Hold")}>
                                                            <Grid
                                                                style={{ 
                                                                    padding: '4px', 
                                                                    pointerEvents: this.isRestricted(BinStatus[i] && BinStatus[i].group_type_id, elem[n] + '' + (n1 + 1)) ? 'none' : (isViewPermissionAllowed ? 'auto' : 'none'),
                                                                    cursor: this.isRestricted(BinStatus[i] && BinStatus[i].group_type_id, elem[n] + '' + (n1 + 1)) ? 'not-allowed' : (isViewPermissionAllowed ? 'pointer' : 'not-allowed')
                                                                }}
                                                                // eslint-disable-next-line no-loop-func
                                                                onClick={(e) => {
                                                                    const binId = elem[n] + '' + (n1 + 1);
                                                                    const groupTypeId = BinStatus[i] && BinStatus[i].group_type_id;
                                                                    if (!this.handleBinClick(binId, groupTypeId, 'Hold', pm_id)) {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                    }
                                                                }}
                                                                key={((elem[n] + ' ' + (n1 + 1)))} 
                                                                item xs={2}
                                                                className={isdisabledDoor ? classes.disabledDoor : classes.kioskDoor}
                                                            >
                                                                <Paper
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        // Apply visual styling for column-restricted bins
                                                                        backgroundColor: this.isRestrictedByColumnMapping(elem[n] + '' + (n1 + 1)) ? '#FFE0B2' : 'transparent',
                                                                        border: this.isRestrictedByColumnMapping(elem[n] + '' + (n1 + 1)) ? '2px solid #FF9800' : 'none',
                                                                    }} 
                                                                    id={elem[n] + '' + (n1 + 1)} 
                                                                    className={isLockedBin ? classes.gridPurpleBin : classes.gridSkyblueback}
                                                                >
                                                                    {
                                                                            this.isRestricted(BinStatus[i] && BinStatus[i].group_type_id, elem[n] + '' + (n1 + 1))
                                                                                ? <LockIcon fontSize='12px' /> : null
                                                                    }
                                                                    &nbsp;{elem[n] + ' ' + (n1 + 1)}
                                                                </Paper>
                                                            </Grid>
                                                        </Tooltip>
                                                    );
                                                }
                                            }
                                            if (deactivatedBins && deactivatedBins.length && deactivatedBins.length > 0 && deactivatedBins.findIndex(D => D === (elem[n] + (n1 + 1))) > -1) {
                                                const deactivatedBinKey = elem[n] + '' + (n1 + 1);
                                                return (
                                                    <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title="DEACTIVATE">
                                                        <Grid
                                                            className={isdisabledDoor ? classes.disabledDoor : classes.kioskDoor}
                                                            style={{ 
                                                                padding: '4px', 
                                                                pointerEvents: [
                                                                    groupTypes.Retail, 
                                                                    groupTypes.Super, 
                                                                    groupTypes.eCommerce, 
                                                                    groupTypes.Audiology
                                                                ].includes(BinStatus[i] && BinStatus[i].group_type_id) ? 'none' : (isViewPermissionAllowed ? 'auto' : 'none'),
                                                                cursor: [
                                                                    groupTypes.Retail, 
                                                                    groupTypes.Super, 
                                                                    groupTypes.eCommerce, 
                                                                    groupTypes.Audiology
                                                                ].includes(BinStatus[i] && BinStatus[i].group_type_id) ? 'not-allowed' : (isViewPermissionAllowed ? 'pointer' : 'not-allowed')
                                                            }}
                                                            onClick={() => this.openbin(deactivatedBinKey)}
                                                            key={elem[n] + ' ' + (n1 + 1)} 
                                                            item xs={2}
                                                        >
                                                            <Paper
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center'
                                                                }} 
                                                                id={deactivatedBinKey} 
                                                                className={classes.gridRedback}
                                                            >
                                                                {
                                                                    // Column mapping: show lock when restricted (priority over status)
                                                                    (this.isRestrictedByColumnMapping(deactivatedBinKey) || this.isRestricted(BinStatus[i] && BinStatus[i].group_type_id, deactivatedBinKey))
                                                                        ? <LockIcon fontSize='12px' /> : null
                                                                }
                                                                &nbsp;{elem[n] + ' ' + (n1 + 1)}
                                                            </Paper>
                                                        </Grid>
                                                    </Tooltip>
                                                );
                                            } else {
                                                return (
                                                    <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title={t("Global.Prescriptions.Status.Available")}>
                                                        <Grid
                                                            style={{ 
                                                                padding: '4px', 
                                                                pointerEvents: [
                                                                    groupTypes.Retail, 
                                                                    groupTypes.Super, 
                                                                    groupTypes.eCommerce, 
                                                                    groupTypes.Audiology
                                                                ].includes(BinStatus[i] && BinStatus[i].group_type_id) ? 'none' : (isViewPermissionAllowed ? 'auto' : 'none'),
                                                                cursor: [
                                                                    groupTypes.Retail, 
                                                                    groupTypes.Super, 
                                                                    groupTypes.eCommerce, 
                                                                    groupTypes.Audiology
                                                                ].includes(BinStatus[i] && BinStatus[i].group_type_id) ? 'not-allowed' : (isViewPermissionAllowed ? 'pointer' : 'not-allowed')
                                                            }}
                                                            onClick={() =>this.openbin(elem[n] + '' + (n1 + 1))}
                                                            key={elem[n] + ' ' + (n1 + 1)} 
                                                            item xs={2}
                                                            className={isdisabledDoor ? classes.disabledDoor : classes.kioskDoor}
                                                        >
                                                            <Paper
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center'
                                                                }}
                                                                id={elem[n] + '' + (n1 + 1)} 
                                                                className={classes.gridback}
                                                            >
                                                                {
                                                                            this.isRestricted(BinStatus[i] && BinStatus[i].group_type_id, elem[n] + '' + (n1 + 1))
                                                                                ? <LockIcon fontSize='12px' /> : null
                                                                }
                                                                &nbsp;{elem[n] + ' ' + (n1 + 1)}
                                                            </Paper>
                                                        </Grid>
                                                    </Tooltip>
                                                );
                                            }
                                        } else {
                                            if (deactivatedBins.length > 0 && deactivatedBins.findIndex(D => D === (elem[n] + (n1 + 1))) > -1) {
                                                const deactivatedBinKey = elem[n] + '' + (n1 + 1);
                                                return (
                                                    <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title="DEACTIVATE">
                                                        <Grid
                                                            className={isdisabledDoor ? classes.disabledDoor : classes.kioskDoor}
                                                            style={{ 
                                                                padding: '4px', 
                                                                pointerEvents: [
                                                                    groupTypes.Retail, 
                                                                    groupTypes.Super, 
                                                                    groupTypes.eCommerce, 
                                                                    groupTypes.Audiology
                                                                ].includes(BinStatus[i] && BinStatus[i].group_type_id) ? 'none' : (isViewPermissionAllowed ? 'auto' : 'none'),
                                                                cursor: [
                                                                    groupTypes.Retail, 
                                                                    groupTypes.Super, 
                                                                    groupTypes.eCommerce, 
                                                                    groupTypes.Audiology
                                                                ].includes(BinStatus[i] && BinStatus[i].group_type_id) ? 'not-allowed' : (isViewPermissionAllowed ? 'pointer' : 'not-allowed')
                                                            }}
                                                            onClick={() => this.openbin(deactivatedBinKey)}
                                                            key={elem[n] + ' ' + (n1 + 1)} 
                                                            item xs={2}
                                                        >
                                                            <Paper
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center'
                                                                }}
                                                                id={deactivatedBinKey} 
                                                                className={classes.gridRedback}
                                                            >
                                                                {
                                                                    // Column mapping: show lock when restricted (priority over status)
                                                                    (this.isRestrictedByColumnMapping(deactivatedBinKey) || this.isRestricted(BinStatus[i] && BinStatus[i].group_type_id, deactivatedBinKey))
                                                                        ? <LockIcon fontSize='12px' /> : null
                                                                }
                                                                &nbsp;{elem[n] + ' ' + (n1 + 1)}
                                                            </Paper>
                                                        </Grid>
                                                    </Tooltip>
                                                );
                                            } else {
                                                return (
                                                    <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title={t("Global.Prescriptions.Status.Available")}>
                                                        <Grid
                                                            style={{ 
                                                                padding: '4px', 
                                                                pointerEvents: [
                                                                    groupTypes.Retail, 
                                                                    groupTypes.Super, 
                                                                    groupTypes.eCommerce, 
                                                                    groupTypes.Audiology
                                                                ].includes(BinStatus[i] && BinStatus[i].group_type_id) ? 'none' : (isViewPermissionAllowed ? 'auto' : 'none'),
                                                                cursor: [
                                                                    groupTypes.Retail, 
                                                                    groupTypes.Super, 
                                                                    groupTypes.eCommerce, 
                                                                    groupTypes.Audiology
                                                                ].includes(BinStatus[i] && BinStatus[i].group_type_id) ? 'not-allowed' : (isViewPermissionAllowed ? 'pointer' : 'not-allowed')
                                                            }}
                                                            onClick={() =>this.openbin(elem[n] + '' + (n1 + 1))}
                                                            key={elem[n] + ' ' + (n1 + 1)} 
                                                            item xs={2}
                                                            className={isdisabledDoor ? classes.disabledDoor : classes.kioskDoor}
                                                        >
                                                            <Paper
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center'
                                                                }}
                                                                id={elem[n] + '' + (n1 + 1)} 
                                                                className={classes.gridback}
                                                            >
                                                                {
                                                                            this.isRestricted(BinStatus[i] && BinStatus[i].group_type_id, elem[n] + '' + (n1 + 1))
                                                                                ? <LockIcon fontSize='12px' /> : null
                                                                }
                                                                &nbsp;{elem[n] + ' ' + (n1 + 1)}
                                                            </Paper>
                                                        </Grid>
                                                    </Tooltip>
                                                );
                                            }
                                        }
                                    }
                                }
                                return true
                            })
                            }
                        </Grid>
                    );
                })}
            </div>
        )
    }
};

export default withStyles(styles)(withTranslation()(Main24Layout));




// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/Main24-layout.js